var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C7.724 2 7.5 2.224 7.5 2.5V12.4747L3.862 8.65525C3.67175 8.4555 3.3555 8.44725 3.155 8.638C2.955 8.8285 2.94725 9.14475 3.13775 9.34475L7.29275 13.707C7.48175 13.896 7.73275 14 8 14C8.267 14 8.51825 13.896 8.7155 13.6982L12.862 9.34475C13.0525 9.14475 13.0445 8.8285 12.8447 8.638C12.645 8.44725 12.3285 8.45525 12.138 8.65525L8.5 12.4908V2.5C8.5 2.224 8.276 2 8 2Z",
    fill: "#07969E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.8cbbd42a81d98e32f885ca53a76b4831.svg";
export { ForwardRef as ReactComponent };